import { IServerSideGetRowsRequest } from "ag-grid-community";
import { getConfiguredCache } from "cache/cache-exp";
import { FC, useEffect, useState } from "react";
import { FilterBar } from "types/Search";
import { uuidv4 } from "utils/uuid.utils";
import { GridDtProps } from "../Datatable.types";
import { GridDtDefinitionState, initialDTState } from "../GridDtReducer";

const TAB_ID = uuidv4();

export type GridDtCacheState = GridDtDefinitionState & {
  searchParams?: IServerSideGetRowsRequest;
  breakRows?: string[];
  filterBar?: FilterBar;
  filterAllFields?: string;
};

export const GRID_DT_CACHE = getConfiguredCache({
  version: 1,
  maxAge: Infinity,
  name: "datatable-cache"
});

export function clearCacheModule(sjmoCode: string) {
  GRID_DT_CACHE.keys().then(keys => {
    for (let key of keys) {
      if (key.includes(sjmoCode + "---")) {
        GRID_DT_CACHE.del(key);
      }
    }
  });
}

export function clearDatatableCache() {
  GRID_DT_CACHE.keys().then(keys => {
    for (let key of keys) {
      if (key.startsWith(TAB_ID)) {
        GRID_DT_CACHE.del(key);
      }
    }
  });
}

export const getGridDtKey = (code: string, key: string, table: string) => {
  return TAB_ID + ":::" + code + "---" + key + "---" + table;
};

export default function withGridDtCache(
  Comp: React.ComponentType<Omit<Omit<GridDtProps, "interactions">, "callbackRefresh">>
) {
  const Wrapper: FC<GridDtProps> = props => {
    const gridDtKey = getGridDtKey(props.sjmoCode, props.ctrlkey, props.tableName);

    const [initialState, setInitialState] = useState<GridDtCacheState | null>(null);

    useEffect(() => {
      GRID_DT_CACHE.get(gridDtKey).then(val => {
        setInitialState(val || initialDTState);
      });
    }, [gridDtKey]);

    useEffect(() => {
      return () => {
        if (props.clearCacheOnClose) {
          GRID_DT_CACHE.del(gridDtKey);
        }
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return initialState == null ? null : <Comp {...props} initialState={initialState} />;
  };
  Wrapper.displayName = "withDatatableCache(" + (Comp.displayName || Comp.name) + ")";

  return Wrapper;
}
